import { Box, Center, BoxProps } from '@chakra-ui/react';
import { Children } from 'react';
import { FCC } from '../../types';

interface Props extends BoxProps {
  isChecked: boolean;
}

const RadioCard: FCC<Props> = ({ children, isChecked, ...props }) => {
  return (
    <Box
      as="label"
      p={0}
      w="full"
      color="primary.500"
      borderRadius="lg"
      borderWidth="1px"
      borderColor="blackAlpha.400"
      backgroundColor="white"
      cursor="pointer"
      fontWeight="medium"
      _hover={{
        borderColor: 'primary.500',
      }}
      {...(isChecked && {
        borderColor: 'primary.500',
        backgroundColor: 'primary.500',
        color: 'whiteAlpha.900',
      })}
      _focus={{
        boxShadow: 'outline',
      }}
      {...(Children.count(children) >= 1 && {
        _first: {
          borderRightRadius: 0,
        },
        _last: {
          borderLeftRadius: 0,
        },
        _notFirst: {
          _notLast: {
            borderRadius: 0,
          },
        },
      })}
      {...props}
    >
      <Center p={2} textAlign="center" w="full" minH={12}>
        {children}
      </Center>
    </Box>
  );
};

export default RadioCard;
